// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3390":"26ced223","4872":"26ced223","7265":"26ced223"}[chunkId] + ".chunk.css";
};